import { Button } from '../../Utility/Button';
import { GlobeIcon, PencilSimpleIcon, TrashIcon, CopyIcon } from '@phosphor-icons/react';
import AdminContainer from '../../Utility/AdminContainer';
import usePrompts from '../../../Hooks/usePrompts';
import AdminBox from '../../Utility/AdminBox';
import { PaginationListType } from '../../../Types/PaginationParams';
import { promptService } from '../../../Services/promptService';
import { Prompt } from '../../../Types';
import AdminViewContent from '../../Utility/AdminViewContent';
import RadioButton from '../../Utility/FormElements/Radiobutton';
import { RootState, useAppSelector } from '../../../store';
import { UserSettings } from '../../../Types';
import PaginatedView from '../../Utility/PaginatedView';

function Prompts() {
    const settings = useAppSelector((state: RootState) => state.settings);
    const userSettings = useAppSelector((state: RootState) => state.userSettings as UserSettings);
    const { PromptsActions, handleCopyPrompt, handleNavigate, i18n, windowWidth, getBreakpoint } = usePrompts();

    const GRID_COLS = 'grid-cols-[minmax(270px,490px),minmax(80px,150px),minmax(157px,1fr)]';

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox classString="px-4">
                    <PaginatedView
                        listType={PaginationListType.Assistants}
                        itemsFunction={promptService.getPromptsByPage}
                        itemsPerPage={15}
                        renderItem={(prompt: Prompt, index: number) => (
                            <AdminViewContent
                                key={prompt.identifier}
                                mobile={windowWidth < getBreakpoint('md')}
                                identifier={prompt.identifier}
                                gridCols={GRID_COLS}
                                cols={{
                                    optionalCols: [
                                        {
                                            content: prompt.name ?? '',
                                            image: prompt.image,
                                            showImage: true,
                                        },
                                        {
                                            content: !prompt.isUserPrompt && (
                                                <RadioButton
                                                    key={prompt.identifier}
                                                    value={prompt.identifier}
                                                    name="base"
                                                    checked={prompt.isBasePrompt}
                                                    onChange={() =>
                                                        PromptsActions.handleOpenConfirmDialogBasePromptChange(
                                                            prompt.identifier,
                                                        )
                                                    }
                                                    label={windowWidth < getBreakpoint('md') ? 'Basis-Assistent' : ''}
                                                    className={windowWidth < getBreakpoint('md') ? 'mt-3' : ''}
                                                />
                                            ),
                                        },
                                    ],
                                    button: {
                                        buttons: [
                                            {
                                                variant: 'primaryRound',
                                                onClick: () => handleNavigate(prompt.identifier),
                                                icon: <PencilSimpleIcon />,
                                            },
                                            {
                                                variant: 'secondaryRound',
                                                onClick: () => handleCopyPrompt(prompt),
                                                icon: <CopyIcon />,
                                            },
                                            {
                                                variant: 'primaryRound',
                                                onClick: () => PromptsActions.handleMakeGlobal(prompt.identifier),
                                                icon: <GlobeIcon />,
                                                hideElement: !prompt.isUserPrompt,
                                                tooltipText: i18n.translate({
                                                    id: 'tooltip.makeGlobal',
                                                    sourceName: 'Prompts',
                                                }),
                                            },
                                            {
                                                variant: prompt.isBasePrompt ? 'disabledRound' : 'secondaryRound',
                                                onClick: () =>
                                                    !prompt.isBasePrompt &&
                                                    PromptsActions.handleOpenConfirmDialog(prompt.identifier),
                                                icon: <TrashIcon />,
                                                hideElement: prompt.isUserPrompt,
                                            },
                                        ],
                                    },
                                }}
                            />
                        )}
                    >
                        {({ filter, list }) => (
                            <>
                                {filter}
                                <div className="mb-4 md:hidden w-full">
                                    {(!settings.demo || userSettings.isSuperAdmin) && (
                                        <Button
                                            className="!m-0 !mb-3 flex justify-center items-center w-full"
                                            onClick={() => handleNavigate('new')}
                                        >
                                            {i18n.translate({
                                                id: 'newAssistant.button',
                                                sourceName: 'Prompts',
                                            })}
                                        </Button>
                                    )}
                                </div>
                                <div className="hidden md:block">
                                    <div className="hidden md:block">
                                        <div className={`grid ${GRID_COLS} gap-4 w-full px-4`}>
                                            <div className="text-lg flex items-center">
                                                <strong>
                                                    {i18n.translate({
                                                        id: 'adminHeader.mainCol',
                                                        sourceName: 'Main',
                                                    })}
                                                </strong>
                                            </div>
                                            <div className="text-lg flex items-center">
                                                <strong>
                                                    {i18n.translate({
                                                        id: 'assistant.basic',
                                                        sourceName: 'Prompts',
                                                    })}
                                                </strong>
                                            </div>
                                            {(!settings.demo || userSettings.isSuperAdmin) && (
                                                <div className="flex justify-end gap-2">
                                                    <Button
                                                        variant="primary"
                                                        className="h-[51px]"
                                                        onClick={() => handleNavigate('new')}
                                                    >
                                                        {i18n.translate({
                                                            id: 'newAssistant.button',
                                                            sourceName: 'Prompts',
                                                        })}
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                        <hr className="border-layout-borderColor mt-5" />
                                    </div>
                                </div>
                                {list}
                            </>
                        )}
                    </PaginatedView>
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default Prompts;
